import { ReactComponent as messageSvg } from "assets/icons/message-square.svg";
import { ReactComponent as personesSvg } from "assets/icons/persones.svg";

export const messagingNavigation = [
  {
    id: "001",
    name: "smsSending",
    to: `/admin/messaging/sms`,
    icon: messageSvg,
  },
  {
    id: "002",
    name: "contacts",
    to: `/admin/messaging/contacts`,
    icon: personesSvg,
  },
];
